import { getAuthenticatedUploadInstance } from './helpers/axios.helpers';

const authenticatedUploadInstance = getAuthenticatedUploadInstance();

export async function upload(formData: FormData): Promise<any> {
  return authenticatedUploadInstance.post('/records', formData);
}
